/**
 * Coup de pouce — Attendu 1091 « manipulation de sommes et différences de
 * nombres relatifs » (automatisme 4e, l. 632). UNE page en DEUX TEMPS,
 * partagée par les trois generator_keys.
 *
 * L'image que l'élève a déjà : la droite graduée des relatifs de 5e (706,
 * 914) et le bond « je pars de, j'avance de ». Un seul exemple, sacrifié :
 * −3 + 8. Temps 1 : le point de départ, −3. Temps 2 : le bond de 8 vers la
 * droite, l'arrivée à 5, le résultat en gros. Une ligne du geste, en langue
 * d'élève : « Je pars de −3, j'avance de 8 : j'arrive à 5. » Une ligne pour
 * le double moins, avec les MÊMES nombres : « −3 − (−8), c'est pareil que
 * −3 + 8 : enlever −8, c'est ajouter 8. » (la carte « Écrire sans
 * parenthèses » et la famille moins_avale, 21 % à la DEPP).
 *
 * SACRIFIÉ : les termes {−3 ; +8} sous toutes leurs écritures (gen_1091,
 * TERMES_SACRIFIES, auto-testé par gen1091.self.test.js).
 * Largeur bornée à 340 px, tailles de 1048, texte dans la figure, aria-label
 * complet. Le signe moins typographique (−) n'est qu'affiché ; les réponses
 * des cartes restent au tiret clavier.
 */

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';

/** La droite de −5 à 6 sur 330 px. */
const X0 = 35;
const PAS = 30;
const Y = 96;
const toX = (n) => X0 + (n + 5) * PAS;

const GRADUATIONS = Array.from({ length: 12 }, (_, k) => {
    const n = k - 5;
    const x = toX(n);
    return `<line x1="${x}" y1="${Y - 6}" x2="${x}" y2="${Y + 6}" stroke="${ENCRE}" stroke-width="${n === 0 ? 2.2 : 1.2}"/>
  <text x="${x}" y="${Y + 22}" font-size="11" text-anchor="middle" fill="${ENCRE}">${n < 0 ? `−${-n}` : n}</text>`;
}).join('\n  ');

const SVG_BOND = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 236" width="100%" style="max-width:340px;height:auto;display:block" role="img" data-etapes="2"
     aria-label="Une droite graduée de moins 5 à 6. Moins 3 plus 8 égale combien ? Temps 1 : un point bleu sur moins 3, je pars de moins 3. Temps 2 : une flèche orange de moins 3 vers la droite, longue de 8, qui arrive sur 5. Moins 3 plus 8 égale 5. Je pars de moins 3, j'avance de 8 : j'arrive à 5. Moins 3 moins moins 8, c'est pareil que moins 3 plus 8 : enlever moins 8, c'est ajouter 8.">
  <text x="200" y="30" font-size="16" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${BLEU}">−3</tspan> + <tspan fill="${ORANGE}">8</tspan> = ?</text>

  <!-- la droite, toujours visible -->
  <line x1="${X0 - 12}" y1="${Y}" x2="${toX(6) + 14}" y2="${Y}" stroke="${ENCRE}" stroke-width="2"/>
  <polygon points="${toX(6) + 22},${Y} ${toX(6) + 12},${Y - 5} ${toX(6) + 12},${Y + 5}" fill="${ENCRE}"/>
  ${GRADUATIONS}

  <!-- temps 1 : le départ -->
  <g data-etape="1">
    <circle cx="${toX(-3)}" cy="${Y}" r="6" fill="${BLEU}"/>
    <text x="${toX(-3)}" y="${Y - 34}" font-size="12" font-weight="bold" text-anchor="middle" fill="${BLEU}">je pars de −3</text>
  </g>

  <!-- temps 2 : le bond de 8, l'arrivée, le résultat, le geste -->
  <g data-etape="2">
    <path d="M ${toX(-3)} ${Y - 10} Q ${(toX(-3) + toX(5)) / 2} ${Y - 62} ${toX(5) - 4} ${Y - 12}" fill="none" stroke="${ORANGE}" stroke-width="2.4"/>
    <polygon points="${toX(5)},${Y - 8} ${toX(5) - 10},${Y - 14} ${toX(5) - 3},${Y - 20}" fill="${ORANGE}"/>
    <text x="${(toX(-3) + toX(5)) / 2 + 26}" y="${Y - 48}" font-size="13" font-weight="bold" text-anchor="middle" fill="${ORANGE}">+ 8</text>
    <circle cx="${toX(5)}" cy="${Y}" r="6" fill="${ORANGE}"/>
    <text x="200" y="158" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${BLEU}">−3</tspan> + <tspan fill="${ORANGE}">8</tspan> = 5</text>
    <text x="200" y="188" font-size="12" text-anchor="middle" fill="${ENCRE}">Je pars de <tspan font-weight="bold" fill="${BLEU}">−3</tspan>, j'avance de <tspan font-weight="bold" fill="${ORANGE}">8</tspan> : j'arrive à <tspan font-weight="bold">5</tspan>.</text>
    <text x="200" y="212" font-size="12" text-anchor="middle" fill="${ENCRE}">−3 − (−8), c'est pareil que −3 + 8 :</text>
    <text x="200" y="228" font-size="12" text-anchor="middle" fill="${ENCRE}">enlever −8, c'est ajouter 8.</text>
  </g>
</svg>`.trim();

const AIDE = { pages: [{ titre: 'Je pars, j\'avance', svg: SVG_BOND }] };

const CP_1091 = {
    flash_texte_trou_saisie: AIDE,
    resultat_qcm_unique: AIDE,
    sens_texte_trou_drag: AIDE,
};

export default CP_1091;
